import * as React from "react";
import { IBaseInputFieldProperty, IPropertyEditorProps, IUIFieldProps, registerUIField } from "../../common";
import { replaceWithData } from "../../../../util";
import { Property, PropertyContainer, PropertyGroup, PropertyGroupTitle, PropertyTitle, } from "../../ui-props/common";
import { FieldProperty, FieldTitle, IFieldTitleProps } from "../../components/FieldTitle";
import { ICardProps, ICardType, ItemCard2 } from "./ItemCard";
import { ItemCardPropertyEditor } from "./ItemCardProperty";
import { DataSourcePropertyEditor } from "../../ui-props/DataSourceProperty";
import { Input, TextArea, ToggleFilter } from "uxp/components";
import { executeAndBind, IDataSource, IDataSourceBinding, useDataSourceContext } from "../../data-source-picker/datasource";
import './ItemCardField.scss';

interface ICardFieldProperty extends IBaseInputFieldProperty, ICardProps {
    fieldLabel: IFieldTitleProps,
    binding: IDataSourceBinding;
    cardType: ICardType;
    aspectRatio: string;
    cardHeight: string;
    web: string;
    mobile: string;

}


export const Field: React.FunctionComponent<IUIFieldProps<ICardFieldProperty>> = (props) => {
    let { value, onChange } = props?.fieldProps || {};
    let datasources: IDataSource[] = props.uiProps?.datasources || [];
    let [dataList, setDataList] = React.useState<any[]>([]);

    let styles: React.CSSProperties = {}

    let { widgetData } = useDataSourceContext() || { widgetData: null };
    let isLiveMode = props.mode !== 'preview' && props.mode !== 'thumbnail';
    let binding = props?.fieldProps?.binding;
    let cardHeight = Number(props?.fieldProps?.cardHeight) || 200;
    React.useEffect(() => {
        if ((!props.mode || (props.mode != 'preview' && props.mode != 'thumbnail'))) {
            if (binding) {

                executeAndBind(props.fieldProps.uxpContext, binding, datasources, {})
                    .then((opts: any[]) => {
                        setDataList(opts);
                    })
                    .catch(console.error);
            }
            else {
                //TODO: setDataList to manually defined items
            }
        }
        else {
            setDataList([{ title: 'My title', subTitle: 'My Subtitle' }]);
        }
    }, [props.mode]);

    let replacer = isLiveMode ?
        (x: string) => replaceWithData(x || '', widgetData)
        : (x: string) => (x || '');


    return (
        <div className={`ui-field-card-carousel ui-field ${props.mode} ${props.fieldProps.cardType}`} >
            <FieldTitle {...props?.fieldProps?.fieldLabel || {}} />
            {
                <div className={'cf-carousel ' + props.fieldProps.cardType} style={{ height: cardHeight + 'px' }}>
                    {dataList.map((dl) => {
                        let rowReplacer = (x: string) => replaceWithData(x || '', { ...widgetData, row: dl });
                        return <ItemCard2 cardType={props.fieldProps.cardType} topBorder={false} bottomBorder={true} {...props?.fieldProps} replacer={rowReplacer} />
                    })}
                </div>
            }
        </div>
    )
}



export const PropertyEditor: React.FunctionComponent<IPropertyEditorProps<ICardFieldProperty>> = (props) => {
    let datasources: IDataSource[] = props.parentUIProps?.datasources || [];

    return <PropertyContainer>
        <PropertyGroup>
            <PropertyGroupTitle>Data Source</PropertyGroupTitle>
            <Property>
                <DataSourcePropertyEditor
                    binding={props.uiProps.binding}
                    context={props.uxpContext}
                    onChange={(binding) => props.onChange(Object.assign({}, props.uiProps, { binding }))}
                    onChangeAny={(p, v) => {
                        props.onChangeAny(p, v);
                    }}
                    sources={datasources}
                    target={'dictionary-array'}
                    title='Data Source'
                    contextData={props.contextData}
                    className='uxp-designer-data-source-selector'
                    designer={props.designer}
                />
            </Property>
        </PropertyGroup>
        <PropertyGroup>
            <PropertyGroupTitle>Card Type</PropertyGroupTitle>
            <Property>
                <ToggleFilter value={props.uiProps.cardType}
                    onChange={(cardType) => props.onChange(Object.assign({}, props.uiProps, { cardType }))}
                    options={[
                        { label: 'Full Image', value: 'image-carousel-1' },
                        { label: 'Half Image', value: 'image-carousel-2' },
                        { label: 'Full Image 2', value: 'image-carousel-3' },
                        { label: 'Simple', value: 'carousel' },
                        { label: 'Custom', value: 'custom' },
                    ]} />

            </Property>
            {
                props.uiProps.cardType == 'custom' && <>
                    <Property>
                        <PropertyTitle>Custom UI (Mobile)</PropertyTitle>
                        <TextArea
                            value={props.uiProps.mobile}
                            onChange={s => {
                                props.onChange({ ...props.uiProps, web: props.uiProps.web, mobile: s, binding: props.uiProps.binding });
                            }}
                        />
                        {/* <textarea value={(props.uiProps.mobile)} onChange={(e) => {
                            props.onChange({ web: props.uiProps.web, mobile: e.target.value });
                        }} /> */}
                    </Property>
                    <Property>
                        <PropertyTitle>Custom UI (Web)</PropertyTitle>
                        {/* <textarea value={(props.uiProps.web)} onChange={(e) => {
                    props.onChange({ mobile: props.uiProps.mobile, web: e.target.value });
                }} /> */}
                        <TextArea
                            value={props.uiProps.web}
                            onChange={s => {
                                props.onChange({ ...props.uiProps, mobile: props.uiProps.mobile, web: s, binding: props.uiProps.binding });
                            }}
                        />
                    </Property>


                </>
            }
            <Property>
                <PropertyTitle>Aspect Ratio</PropertyTitle>
                <Input type='number' value={(props.uiProps.aspectRatio)} onChange={(e) => {
                    props.onChange(Object.assign({}, props.uiProps, { aspectRatio: e }));
                }} />
            </Property>
            <Property>
                <PropertyTitle>Card Height</PropertyTitle>
                <Input type='number' value={(props.uiProps.cardHeight)} onChange={(e) => {
                    props.onChange(Object.assign({}, props.uiProps, { cardHeight: e }));
                }} />
            </Property>
        </PropertyGroup>
        <ItemCardPropertyEditor uxpContext={props.uxpContext} onChange={props.onChange} parentUIProps={props.parentUIProps} uiProps={props.uiProps} contextData={{}} />
        <FieldProperty uiProps={props.uiProps} onChange={props.onChange} />
    </PropertyContainer>;
}

registerUIField({
    id: 'item-card-carousel',
    category: 'cards-media',
    description: 'Item Card Carousel',
    field: Field,
    propertyEditor: PropertyEditor,
    isInputField: true,
    defaultProps: {
        fieldLabel: {
            label: 'Text Label',
        },
        web: '',
        mobile: '',
        binding: null,
        cardHeight: '200',
        aspectRatio: '1',
        imageField: '',
        imageType: '',
        imageSize: '30',
        imageBorderType: 'square',
        imageBackgroundColor: '',
        imageIcon: '',
        imageIconColor: '',
        titleField: '',
        titleColor: '',
        titleSize: '',
        subTitleField: '',
        subTitleColor: '',
        subTitleSize: '',
        borderColor: '',
        topLabels: [],
        bottomLabels: [],
        buttons: [],
        cardType: 'image-carousel-1',
        onClick: null,
    },
});

